import PropTypes from 'prop-types';

export default null;

export const labelsPropTypes = PropTypes.shape({
  advancedLabel: PropTypes.string,
  buttonLabel: PropTypes.string,
  categoriesLabel: PropTypes.string,
  dateFromPlaceholder: PropTypes.string,
  datesInfo: PropTypes.string,
  datesLabel: PropTypes.string,
  dateToPlaceholder: PropTypes.string,
  event: PropTypes.string,
  keywordsInfo: PropTypes.string,
  keywordsLabel: PropTypes.string,
  keywordsPlaceholder: PropTypes.string,
  locationInfo: PropTypes.string,
  locationLabel: PropTypes.string,
  locationPlaceholder: PropTypes.string,
  meet: PropTypes.string,
  mobileAccordionCloseLabel: PropTypes.string,
  mobileAccordionOpenLabel: PropTypes.string,
  name: PropTypes.string,
  noResultsLabel: PropTypes.string,
  placeOfInterest: PropTypes.string,
  radiusInfo: PropTypes.string,
  radiusLabel: PropTypes.string,
  radiusPlaceholder: PropTypes.string,
  resetButtonLabel: PropTypes.string,
  resultCtaButtonLabel: PropTypes.string,
  resultsSummary: PropTypes.string,
  showAllLabel: PropTypes.string,
  showEventsLabel: PropTypes.string,
  temporaryHolidaySite: PropTypes.string,
  title: PropTypes.string,
  typesLabel: PropTypes.string,
});

export const resultPropTypes = PropTypes.shape({
  isPlaceOfInterest: PropTypes.bool,
  imageUrl: PropTypes.string,
  url: PropTypes.string,
  title: PropTypes.string,
  description: PropTypes.string,
  highlight: PropTypes.shape({
    description: PropTypes.string,
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  price: PropTypes.string,
  date: PropTypes.string,
  time: PropTypes.string,
});

export const tagsPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
  })
);

export const globalsPropTypes = PropTypes.shape({
  globals: PropTypes.shape({
    categories: tagsPropTypes,
    defaultImageUrls: PropTypes.arrayOf(PropTypes.string),
    isExperienceEditor: PropTypes.bool,
    googleApiKey: PropTypes.string.isRequired,
    labels: labelsPropTypes,
    pageSize: PropTypes.number,
    parentItemId: PropTypes.string.isRequired,
    defaultLocationRadiusValue: PropTypes.number.isRequired,
    radiusOptions: PropTypes.arrayOf(
      PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string.isRequired,
      })
    ),
    types: tagsPropTypes,
  }),
});

export const dataAttributePropTypes = PropTypes.shape({
  radiusOptions: PropTypes.shape({
    16: PropTypes.string,
    32: PropTypes.string,
    48: PropTypes.string,
    128: PropTypes.string,
    160: PropTypes.string,
  }),
  categories: tagsPropTypes,
  types: tagsPropTypes,
  pageSize: PropTypes.number,
  defaultRadiusValue: PropTypes.number,
});

export const paramsPropTypes = PropTypes.shape({}); // @TODO add in details
